import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'


import ExpertManagementPlan from './ExpertManagementPlan'
import Managementcomparison from './Managementcomparison'
import AuditAndContact from './Auditandcontact'
function PropertyManagementIndex() {
  return (
    <div>
      <Navbar />
      <ExpertManagementPlan />
        <Managementcomparison />
        <AuditAndContact />
      <Footer/>
    </div>
  )
}

export default PropertyManagementIndex
